import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import useSWR, { SWRConfiguration } from 'swr'
import { StandaloneChart, StandaloneChartSchema } from 'types'

export const useResolvedChart = (
  chartId: string | undefined,
  config?: SWRConfiguration<StandaloneChart, Error>
) => {
  const { authorizedAxios } = useGeckoAuth()
  const { TIME_SERIES_SERVICE } = useRuntimeVariables()

  const fetcher = async (url: string): Promise<StandaloneChart> => {
    const response = await authorizedAxios.get(url)
    return StandaloneChartSchema.parse(response.data)
  }

  const { data, ...rest } = useSWR<StandaloneChart, Error>(
    chartId ? `${TIME_SERIES_SERVICE}/api/v1/chart/${chartId}/resolved` : null,
    fetcher,
    config
  )

  return {
    chart: data,
    ...rest,
  }
}
